import type { ComponentType, MouseEvent, ReactNode } from 'react';

import { StyledBasicParagraph, StyledIcon, Wrapper } from './GameControlButton.styled';

interface GameControlButton {
  Icon: ComponentType;
  children?: ReactNode;
  expandRight?: boolean;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  onHover?: (e: MouseEvent<HTMLDivElement>) => void;
  onBlur?: (e: MouseEvent<HTMLDivElement>) => void;
}

export const GameControlButton = ({
  Icon,
  children,
  expandRight,
  onClick: handleClick,
  onHover: handleHover,
  onBlur: handleBlur,
}: GameControlButton) => {
  return (
    <Wrapper
      onClick={handleClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleBlur}
      $hasText={!!children}
      $expandRight={expandRight}
    >
      <StyledIcon as={Icon} />

      {children}
    </Wrapper>
  );
};

GameControlButton.Text = StyledBasicParagraph;
